// extracted by mini-css-extract-plugin
var _1 = "CheckoutUtil__ellip--F3ec6";
var _2 = "CheckoutUtil__label--b_HaE";
export { _1 as "ellip", _2 as "label" }
